import { ArrowLeft } from "lucide-react";
import { X } from "lucide-react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "../../../../shared/ui";
import { MemberOption } from "./MemberSelectionDropdown";
import MemberSelectionDropdown from "./MemberSelectionDropdown";

type ReassignCustomersModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCustomersCount: number;
  selectedMemberId: string;
  memberOptions: MemberOption[];
  memberQuery: string;
  isMemberDropdownOpen: boolean;
  onMemberDropdownOpenChange: (open: boolean) => void;
  onMemberQueryChange: (value: string) => void;
  onSelectMember: (memberId: string) => void;
  onBackToCustomers: () => void;
  onCancel: () => void;
  onSaveChanges: () => void;
  isSaving: boolean;
  error?: string | null;
};

const ReassignCustomersModal = ({
  open,
  onOpenChange,
  selectedCustomersCount,
  selectedMemberId,
  memberOptions,
  memberQuery,
  isMemberDropdownOpen,
  onMemberDropdownOpenChange,
  onMemberQueryChange,
  onSelectMember,
  onBackToCustomers,
  onCancel,
  onSaveChanges,
  isSaving,
  error,
}: ReassignCustomersModalProps) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      contentClassName="max-w-[600px]"
    >
      <ModalHeader className="relative justify-center">
        <ModalTitle className="text-center">
          Reassign {selectedCustomersCount.toLocaleString()} customers
        </ModalTitle>
        <button
          type="button"
          aria-label="Close modal"
          className="absolute right-6 top-6 rounded-full p-2 text-[#737AA8] hover:bg-[#F2F4FF]"
          onClick={onCancel}
          disabled={isSaving}
        >
          <X size={20} />
        </button>
      </ModalHeader>

      <ModalBody className="space-y-4 pt-4">
        <div>
          <div className="mb-2 text-[16px] font-[500] text-[#3A3E5B]">
            Reassign customers to
          </div>
          <MemberSelectionDropdown
            open={isMemberDropdownOpen}
            onOpenChange={onMemberDropdownOpenChange}
            members={memberOptions}
            selectedMemberId={selectedMemberId}
            onSelectMember={onSelectMember}
            query={memberQuery}
            onQueryChange={onMemberQueryChange}
            placeholder="Select member"
          />
        </div>
      </ModalBody>

      <ModalFooter className="justify-between">
        <button
          type="button"
          className="inline-flex h-11 items-center gap-2 text-[18px] font-[500] text-[#2C2F44]"
          onClick={onBackToCustomers}
          disabled={isSaving}
        >
          <ArrowLeft size={20} />
          Back to customers
        </button>

        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            className="h-11 rounded-[14px] px-6 text-[#2C2F44]"
            onClick={onCancel}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            className="h-11 rounded-[14px] px-6"
            onClick={onSaveChanges}
            disabled={!selectedMemberId || isSaving}
          >
            {isSaving ? "Saving..." : "Save changes"}
          </Button>
        </div>
      </ModalFooter>
      {error ? <div className="px-6 pb-6 text-[14px] text-[#C24E4E]">{error}</div> : null}
    </Modal>
  );
};

export default ReassignCustomersModal;
